/* Ribbon and Revel · Delivery-method chooser behaviour.
 *
 * Drives snippets/delivery-method-picker.liquid on both the cart drawer and the
 * /cart page. Persists the buyer's choice to cart attributes, which ride along
 * to the order as note_attributes and are read by the studio dashboard
 * (app/lib/local-pickup.server.ts).
 *
 * Everything is delegated off `document`, so the cart drawer can re-render its
 * markup as often as it likes without needing to re-bind anything.
 *
 * LOAD-BEARING STRINGS — kept in sync with the snippet + the dashboard reader:
 *   attribute "Delivery method"  values "Local pickup" | (cleared)
 *   attribute "Pickup ZIP"
 *
 * Choosing "Ship it to me" CLEARS both attributes rather than writing
 * "Ship", so a normal order's Admin page and confirmation email look exactly
 * as they did before this feature existed. Only pickup orders carry attributes.
 */
(function () {
  var ATTR_METHOD = 'Delivery method';
  var ATTR_ZIP = 'Pickup ZIP';
  var PICKUP = 'Local pickup';

  var zipTimer = null;

  function post(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/update.js ' + r.status);
        return r.json();
      })
      .catch(function (e) {
        console.error('[rr-delivery-method]', e);
      });
  }

  /** Parse the eligible-ZIP allowlist off the fieldset's data-zips. */
  function zipList(fieldset) {
    var raw = (fieldset && fieldset.getAttribute('data-zips')) || '';
    return raw
      .split(/[\s,;]+/)
      .map(function (z) {
        return z.trim();
      })
      .filter(function (z) {
        return /^\d{5}$/.test(z);
      });
  }

  /**
   * Reflect a choice into every picker on the page (drawer + /cart can both be
   * mounted at once) without firing another change event.
   */
  function paint(isPickup) {
    document.querySelectorAll('[data-rr-delivery]').forEach(function (fs) {
      fs.querySelectorAll('[data-rr-delivery-input]').forEach(function (input) {
        var wants = input.value === PICKUP;
        input.checked = wants === isPickup;
        var label = input.closest('[data-rr-delivery-label]');
        if (label) label.classList.toggle('is-selected', input.checked);
      });
      var panel = fs.querySelector('[data-rr-delivery-panel]');
      if (panel) panel.hidden = !isPickup;
    });
  }

  /** Show ZIP eligibility feedback. state: '' | 'ok' | 'out' */
  function zipMessage(state, text) {
    document.querySelectorAll('[data-rr-zip-msg]').forEach(function (el) {
      el.setAttribute('data-state', state);
      el.textContent = text;
    });
  }

  /**
   * Courtesy eligibility check. Both messages come off the fieldset's data
   * attributes, which the Liquid snippet fills from theme settings — the copy is
   * never duplicated here. Liquid also server-renders the initial verdict, so
   * this only has to handle live typing.
   *
   * Advisory only: Shopify's shipping zone is what actually decides whether the
   * pickup rate appears, so a stale ZIP list here can't create a pricing hole.
   */
  function checkZip(fieldset, zip) {
    var list = zipList(fieldset);
    if (!zip || !/^\d{5}$/.test(zip)) {
      zipMessage('', '');
      return null;
    }
    if (list.length === 0 || list.indexOf(zip) !== -1) {
      zipMessage('ok', fieldset.getAttribute('data-zip-ok') || '');
      return true;
    }
    zipMessage('out', fieldset.getAttribute('data-zip-out') || '');
    return false;
  }

  // ── Method change ──────────────────────────────────────────────────────
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-rr-delivery-input]');
    if (!input) return;

    var isPickup = input.value === PICKUP;
    paint(isPickup);

    if (!isPickup) {
      zipMessage('', '');
      var cleared = {};
      cleared[ATTR_METHOD] = '';
      cleared[ATTR_ZIP] = '';
      post(cleared);
      return;
    }

    var fieldset = input.closest('[data-rr-delivery]');
    var zipInput = fieldset ? fieldset.querySelector('[data-rr-pickup-zip]') : null;
    var zip = zipInput ? zipInput.value.trim() : '';
    if (fieldset) checkZip(fieldset, zip);

    var next = {};
    next[ATTR_METHOD] = PICKUP;
    if (zip) next[ATTR_ZIP] = zip;
    post(next);
  });

  // ── ZIP entry (debounced) ──────────────────────────────────────────────
  document.addEventListener('input', function (e) {
    var zipInput = e.target.closest && e.target.closest('[data-rr-pickup-zip]');
    if (!zipInput) return;

    var fieldset = zipInput.closest('[data-rr-delivery]');
    if (!fieldset) return;

    // Digits only, max 5 — keeps the allowlist comparison simple.
    var zip = zipInput.value.replace(/\D/g, '').slice(0, 5);
    if (zip !== zipInput.value) zipInput.value = zip;

    // Mirror into the other picker instance so drawer and page agree.
    document.querySelectorAll('[data-rr-pickup-zip]').forEach(function (other) {
      if (other !== zipInput) other.value = zip;
    });

    checkZip(fieldset, zip);

    clearTimeout(zipTimer);
    zipTimer = setTimeout(function () {
      var attrs = {};
      attrs[ATTR_ZIP] = zip;
      post(attrs);
    }, 400);
  });

  // No load-time initialisation needed: the Liquid snippet server-renders the
  // selected option, the panel's open/closed state and the ZIP verdict, so the
  // markup is already correct on first paint and after every cart re-render.
})();
